export default __webpack_public_path__ + "static/media/guide0206_m.1bf84efb.jpg";